// extracted by mini-css-extract-plugin
export default {"header":"FilterHeader_header__RQlCY","searchContainer__textfield":"FilterHeader_searchContainer__textfield__t9Amy"};